import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const VRVARoute = props => {
  const { isVR } = useContext(UserContext);

  if (isVR) {
    return <Route {...props} />;
  } else if (!isVR) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default VRVARoute;
